'use client'

import { FunctionComponent } from 'react'
import { useTranslation } from '../../../context/ConfigContext'
import InformationFrame from '../InformationFrame'

const MyMoveInformation: FunctionComponent = () => {
  const t = useTranslation()
  return (
    <section className='information-cart'>
      <InformationFrame align='left'>
        <p className='p16'>{t('catalog-product-mymove-notice')}</p>
      </InformationFrame>
    </section>
  )
}

export default MyMoveInformation
